import(/* webpackMode: "eager" */ "/app/app/tests/demo/page.tsx");
